import Service from '@ember/service';

export interface Logger {
  log(...args: unknown[]): void;
  info(...args: unknown[]): void;
  warn(...args: unknown[]): void;
  error(...args: unknown[]): void;
  time(label?: string): void;
  timeEnd(label?: string): void;
}
// Logging Service: Centralizes logging for the application so we can filter it or direct it as we please.

// It's what this service *does* :)
export default class LoggingService extends Service implements Logger {
  log(...args: unknown[]): void {
    console.log(...args);
  }
  info(...args: unknown[]): void {
    console.info(...args);
  }
  warn(...args: unknown[]): void {
    console.warn(...args);
  }
  error(...args: unknown[]): void {
    console.error(...args);
  }
  time(label?: string): void {
    console.time(label);
  }
  timeEnd(label?: string): void {
    console.timeEnd(label);
  }
}

declare module '@ember/service' {
  interface Registry {
    logger: LoggingService;
  }
}
